import { useEffect } from "react";

export const useDisableScroll = ()=>{
    useEffect(() => {
 
        document.body.style.overflow = 'hidden'
    
        return () => {
            document.body.style.overflow = 'auto'
        };
      }, []);
}